import { memo } from 'react';
import { cn } from '@/shared/lib/utils';
import styles from './TruncatedSecondaryTitle.module.scss';

interface TruncatedSecondaryTitleProps {
  text: string;
  className?: string;
}

const TruncatedSecondaryTitle = memo(({ text, className }: TruncatedSecondaryTitleProps) => {
  return (
    <span className={cn(styles.secondaryTitle, className)}>
      {text}
    </span>
  );
});

TruncatedSecondaryTitle.displayName = 'TruncatedSecondaryTitle';

export { TruncatedSecondaryTitle };
